import * as Yup from 'yup';
import { Dto } from "../../../parts/crud/dto";



export class userDto extends Dto {
  constructor() {
    super();
    this.data.initialValues = {
      firstname: '',
      lastname: '',
      username: '',
      email: '',
      role_id: '',
      password: '',
      password_confirm: ''
    };


    this.data.validationSchema = Yup.object({
      firstname: Yup.string().required('Il campo nome è obbligatorio'),
      lastname: Yup.string().required('Il campo congome obbligatorio'),
      email: Yup.string().email('Indirizzo email non valido').required('Il campo email è obbligatorio'),
      username: Yup.string().required('Il campo username è obbligatorio'),
      role_id: Yup.string().required('Il campo ruolo è obbligatorio'),
      password: Yup.string().required('Il campo password è obbligatorio').min(9, 'La password deve essere di almeno 9 caratteri'),
      password_confirm: Yup.string().required('Il campo conferma password è obbligatorio').oneOf([Yup.ref('password'), ""], 'Le password non corrispondono')
    })
  }

  hookIsEdit = () => {
    this.data.validationSchema = Yup.object({
      firstname: Yup.string().required('Il campo nome è obbligatorio'),
      lastname: Yup.string().required('Il campo congome obbligatorio'),
      email: Yup.string().email('Indirizzo email non valido').required('Il campo email è obbligatorio'),
      username: Yup.string().required('Il campo username è obbligatorio'),
      role_id: Yup.string().required('Il campo ruolo è obbligatorio'),
      password: Yup.string().min(9, 'La password deve essere di almeno 9 caratteri'),
      password_confirm: Yup.string().oneOf([Yup.ref('password')], 'Le password non corrispondono')
    })
  }

  
}